import { useCallback, useEffect, useRef, useState } from 'react';
import { fetchMockTestAccess } from '../utils/mockTestAccess';

export default function useMockTestAccess() {
  const [access, setAccess] = useState(null);
  const [error, setError] = useState(null);
  const generation = useRef(0);
  const refresh = useCallback(async () => {
    const request = ++generation.current;
    setError(null);
    try {
      const next = await fetchMockTestAccess();
      if (request === generation.current) setAccess(next);
    } catch (failure) {
      if (request === generation.current) {
        setAccess(null);
        setError(failure.message);
      }
    }
  }, []);
  useEffect(() => {
    refresh();
    const reenter = () => { if (document.visibilityState === 'visible') refresh(); };
    window.addEventListener('focus', refresh);
    document.addEventListener('visibilitychange', reenter);
    return () => {
      generation.current += 1;
      window.removeEventListener('focus', refresh);
      document.removeEventListener('visibilitychange', reenter);
    };
  }, [refresh]);
  return { access, error, refresh };
}
